module.exports = __webpack_public_path__ + "static/media/ic-full-marketing-support-in-house.11306fe1.svg";